import React  from "react";
import { useEffect, useState } from 'react';
import {Button,Card,Form,Container,Row,Col} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
//import ListadoActividadFecha from "components/Elements/ListadoActividadFecha";
import {useProyectos} from '../hooks/useProyectos';

function EditarProyecto(){
  const parametros = useParams();
  const { proyectoPorActualizar,setProyectoPorActualizar,updateProyecto,
    updateRespuestaActualizarProyecto,respuestaActualizarProyecto} = useProyectos(parametros.proyectoId);
  const [isChangedElements,setChange]=useState(false);
  
const actualizarProyecto = async() => {
  setChange(false);
  const resp=await updateProyecto(proyectoPorActualizar);
  setChange(true);
};
/*
useEffect( async() => {
  await updateRespuestaActualizarProyecto();  
  
}, [isChangedElements]);
*/
useEffect( () => {
  async function editarProyectoFuncion(){
     updateRespuestaActualizarProyecto();  
  }
  editarProyectoFuncion();
  
  
}, [isChangedElements]);

  return (
    <>
      <Container fluid>
      <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Editar Proyecto</Card.Title>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col xs="6">
                  <label>Nombre</label>
                  <Form.Control
                    value={proyectoPorActualizar?.Nombre}
                    placeholder=""
                    type="text"
                   onChange={(e,prop) => { 
                      setProyectoPorActualizar({...proyectoPorActualizar,['Nombre']:e.target.value});
                    }}
                    rows={12}>
                  </Form.Control>
                  </Col>
                  <Col xs="6">
                    <label>Fecha Inicio</label>
                    <Form.Control
                      type="date"
                      onChange={(e,prop) => { 
                        setProyectoPorActualizar({...proyectoPorActualizar,['FechaInicio']:e.target.value});
                      }}
                      placeholder=""
                      value={proyectoPorActualizar?.FechaInicio?.substring(0,10)}
                      >
                    </Form.Control>
                  </Col>
                </Row>
                <Row>
                  <Col xs="6">
                    <label>Fecha Término</label>
                    <Form.Control
                      type="date"
                      onChange={(e,prop) => { 
                        setProyectoPorActualizar({...proyectoPorActualizar,['FechaTermino']:e.target.value});
                      }}
                      placeholder=""
                      value={proyectoPorActualizar?.FechaTermino?.substring(0,10)}
                      >
                    </Form.Control>
                  </Col>
                </Row>
                           
                <Row>
                  <Col xs="12">
                    <label>Descripción</label>
                    <Form.Control
                      value={proyectoPorActualizar?.Descripcion}
                      placeholder=""
                      type="textarea"
                      as="textarea"
                      onChange={(e,prop) => { 
                        setProyectoPorActualizar({...proyectoPorActualizar,['Descripcion']:e.target.value});
                      }}
                      rows={12}>
                    </Form.Control>
                              
                   </Col>
                              
                </Row>
                <MensajeAlerta mensajeTexto={respuestaActualizarProyecto.mensajeTexto} estado={respuestaActualizarProyecto.estado} />
                <Row>
                  <Col xs="6">
                  </Col>
                  <Col xs="6">
                    <br></br>
                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                        onClick={(e)=>{
                                       e.preventDefault();
                                       actualizarProyecto();
                        }}>
                        Actualizar Proyecto
                      </Button>
                      <br></br>
                  </Col>
                  </Row>
                  <br></br>
                  <br></br>
                 

              </Card.Body>
            </Card>
            <br></br>
                    <br></br>
          </Col>
        </Row>
    </Container>
    </>
  );
}
export default EditarProyecto;
